export enum LocalStorage {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  USER = "user",
  USER_ID = "userId",
  COLORS = "colors",
  COMPANY_ID = "companyId",
  PROFILE = "profile",
  PERMISSIONS = "permissions",
  ROLE_ID = "roleId",
}
